import React from 'react';
import { IoOpenOutline } from '../../node_modules/react-icons/io5/index.js';
import styles from './styles.module.css.js';

function getKey(item) {
  return item.key;
}
function KPIs(props) {
  const {
    data
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, data.map(kpi => /*#__PURE__*/React.createElement("div", {
    className: styles.item,
    key: getKey(kpi),
    style: {
      backgroundColor: kpi.backgroundColor
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.heading
  }, /*#__PURE__*/React.createElement("div", {
    style: kpi.titleStyle
  }, kpi.title), /*#__PURE__*/React.createElement("div", {
    style: kpi.subtitleStyle
  }, kpi.subtitle)), /*#__PURE__*/React.createElement("div", {
    className: styles.value
  }, kpi.value !== 0 && /*#__PURE__*/React.createElement("div", {
    style: kpi.valueStyle
  }, kpi.value), /*#__PURE__*/React.createElement("div", {
    className: styles.right
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.date
  }, kpi.date), kpi.url !== undefined && /*#__PURE__*/React.createElement("a", {
    style: kpi.sourceStyle,
    className: styles.link,
    href: kpi.url,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(IoOpenOutline, null), kpi.source))))));
}

export { KPIs as default };
//# sourceMappingURL=index.js.map
